import React, { useMemo } from 'react';
import { Select } from 'antd';
import './ChangeRequestScopeSelect.less';
import { ChangeRequestListingScope } from '../../enums/changeRequest';
import { DefaultOptionType } from 'antd/es/select';
import classNames from 'classnames';

type ChangeRequestScopeSelectProps = {
  className?: string;
  scope: ChangeRequestListingScope;
  size?: 'small' | 'middle' | 'large';
  onSelect?: (scope: ChangeRequestListingScope) => void;
  onChange?: (scope: ChangeRequestListingScope) => void;
};

const ChangeRequestScopeSelect: React.FC<ChangeRequestScopeSelectProps> = ({
  className,
  scope,
  size = 'middle',
  onSelect,
  onChange,
}) => {
  const scopeOptions = useMemo<DefaultOptionType[]>(() => {
    return [
      {
        value: ChangeRequestListingScope.MY,
        label: 'My Change Requests',
      },
      { value: ChangeRequestListingScope.ALL, label: 'All Change Requests' },
    ].map((opt) => ({
      ...opt,
      className: `change-request-scope-select-option scope-option-${size}`,
    }));
  }, [size]);

  return (
    <div className={classNames('change-request-scope-select', className)}>
      <Select
        className="listing-scope-select"
        size={size}
        value={scope}
        options={scopeOptions}
        onSelect={onSelect}
        onChange={onChange}
      />
    </div>
  );
};

export default ChangeRequestScopeSelect;
